import React  from "react";
import { connect } from "react-redux";
import HyvidStore from "./components/HyvidStore";

const Store = () => {
  return (
    <HyvidStore />
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Store);